/**
 * 「問題に戻る」の戻り先（problem-format.md §6.3）。問題の画面からレッスンへのリンクを押したときに、
 * その問題の id をアプリのメモリに持つ。URL には載せず、再読み込みで消える。
 */
class ReturnTo {
  problemId = $state<string | null>(null);

  set(problemId: string): void {
    this.problemId = problemId;
  }

  clear(): void {
    this.problemId = null;
  }
}

export const returnToProblem = new ReturnTo();
